(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-generation"] && !Shopify.designMode) return;
  try {
    
    // alert("Loaded successful.");
    document.getElementById('uploadForm').addEventListener('submit', async function(event) {
        event.preventDefault(); // Prevent default form submission

        let fileInput = document.getElementById('image');
        let file = fileInput.files[0];
        let emailInput = document.getElementById('email').value;

        let emailError = document.getElementById('emailError');
        let imageError = document.getElementById('imageError');
        let sizeError = document.getElementById('sizeError');

        // Reset error messages
        emailError.style.display = 'none';
        imageError.style.display = 'none';
        sizeError.style.display = 'none';

        if (!file) {
            imageError.style.display = 'block';
            return;
        }

        // Check file size (max 2MB)
        if (file.size > 2 * 1024 * 1024) {  // 2MB
            sizeError.style.display = 'block';
            return;
        }

        if (!emailInput || !validateEmail(emailInput)) {
            emailError.style.display = 'block';
            return;
        }

        let formData = new FormData();
        formData.append("email", emailInput);
        formData.append("profile", file);
        // alert("Loaded successful.");

        try {
            let response = await fetch('http://104.237.2.147:5000/', {
                method: 'POST',
                body: formData
            });

            let result = await response.blob();

            const url = window.URL.createObjectURL(result);
            const a = document.createElement("a");
            a.href = url;
            a.download = "downloaded_image.png";  // Set file name
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);  // Clean up memory

            console.log(result);
            alert("Upload successful.");
        } catch (error) {
            console.error('Error:', error);
            alert("Upload failed.");
        }
    });

    function validateEmail(email) {
        const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return re.test(email);
    }

  } catch(e) { console.error(e); }
})();
})();
